// This enum is a display catalogue of known Airbnb cancellation policies, not an
// exhaustive value set. `airbnbSettings.cancellationPolicy` is a raw string coming from
// Airbnb's catalogue (via `airbnbSettings.eligibleCancellationPolicies`), and values outside
// this catalogue are valid and expected — see `utils/airbnb/cancellationPolicyUtils.ts` for
// how unknown values are labeled.
export enum AirbnbCancellationPolicy {
  FLEXIBLE = 'flexible',
  MODERATE = 'moderate',
  BETTER_STRICT_WITH_GRACE_PERIOD = 'better_strict_with_grace_period',
  FIRM_14 = 'firm_14',
  STRICT = 'strict',
  STRICT_14_WITH_GRACE_PERIOD = 'strict_14_with_grace_period',
  SUPER_STRICT_30 = 'super_strict_30',
  SUPER_STRICT_60 = 'super_strict_60',
}
